import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import MasterTabs from "../AllTabs/MasterTabs";

const initialFieldValues = {
  userId: "00000000-0000-0000-0000-000000000000",
  branchId: "00000000-0000-0000-0000-000000000000",
  name: "",
  userName: "",
  password: "",
  email: "",
  phoneNumber: "",
  roleName: "STAFF",
  isActive: true,
};

const Users = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [branches, setBranches] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [changeShow, setChangeShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [itemToChangeStatus, setItemToChangeStatus] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleOpenStatusModal = (user) => {
    setItemToChangeStatus(user);
    setShowStatusModal(true);
  };

  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
    setItemToChangeStatus(null);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);
    setAddShow(true);
  };

  const handleChangeClose = () => {
    setChangeShow(false);
    setRecordForEdit(null);
  };

  const handleChangeShow = (data) => {
    setValues(data);
    setChangeShow(true);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetBranches = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETBRANCHBYCOMPANY}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    setBranches(res.data);
  };

  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETUSERSBYCOMPANY}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };

  const GetLastPageData = () => {
    GetData(totalPages);
  };

  const GetFirstPageData = () => {
    GetData("1");
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEUSER, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const handleStatusChange = async () => {
    if (itemToChangeStatus !== null) {
      try {
        const updatedUser = {
          ...itemToChangeStatus,
          isActive: !itemToChangeStatus.isActive,
        };

        await apiService.update(config.UPDATEUSER, updatedUser);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseStatusModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.branchId =
      values.branchId === "00000000-0000-0000-0000-000000000000" ? false : true;
    temp.name = values.name === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    temp.password = values.password === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        userId: values.userId,
        userName: values.phoneNumber,
        password: values.password,
        name: values.name,
        email: values.email,
        phoneNumber: values.phoneNumber,
        branchId: values.branchId,
        roleName: values.roleName,
        isActive:
          values.isActive === "true"
            ? true
            : values.isActive === true
            ? true
            : false,
      };
      try {
        const isNew =
          formData.userId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEUSER, formData);
        } else {
          await apiService.update(config.UPDATEUSER, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        userId: values.userId,
        oldpassword: values.password,
        newpassword: values.password,
      };
      try {
        const isNew =
          formData.userId === "00000000-0000-0000-0000-000000000000";

        if (!isNew) {
          await apiService.create(config.CHANGEPASSWORD, formData);
        }
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
    setChangeShow(false);
    setShowPassword(false);
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
      GetBranches(pageNumber);
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MasterTabs pageName="USER" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          User
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="table-light">
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Username</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Branch</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.userId}>
                              <td>{index + 1}</td>
                              <td>{v.name}</td>
                              <td>{v.userName}</td>
                              <td>{v.email}</td>
                              <td>{v.phoneNumber}</td>
                              <td>{v.branchName}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    v.isActive ? "bg-success" : "bg-danger"
                                  } fs-6`}
                                >
                                  {v.isActive ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  {/* <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Change Status"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={() => handleOpenStatusModal(v)}
                                    >
                                      <i
                                        className={`ri-${
                                          v.isActive ? "forbid" : "check"
                                        }-line align-bottom ${
                                          v.isActive
                                            ? "text-danger"
                                            : "text-success"
                                        }`}
                                      />
                                    </Link>
                                  </li> */}
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Change Status"
                                  >
                                    {/* Only show the status change button if branch type is not "main" */}
                                    {v.branchName !== "MAIN" && (
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => handleOpenStatusModal(v)}
                                      >
                                        <i
                                          className={`fs-5 ${
                                            v.isActive
                                              ? "ri-user-unfollow-line text-danger"
                                              : "ri-user-follow-line text-success"
                                          }`}
                                        />
                                      </Link>
                                    )}
                                  </li>
                                  {/* <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Change Password"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => handleChangeShow(v)}
                                    >
                                      <i className="ri-key-fill align-bottom text-muted" />
                                    </Link>
                                  </li> */}
                                  {/* <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.userId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li> */}
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add/Edit User Modal */}
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header>
            <Modal.Title>
              {values.userId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              User
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-4 mb-3">
                  <label htmlFor="name" className="form-label">
                    Branch
                  </label>
                  <select
                    value={values.branchId}
                    name="branchId"
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("branchId")}
                  >
                    <option value="00000000-0000-0000-0000-000000000000">
                      Please select branch
                    </option>
                    {branches.length > 0 &&
                      branches.map((b) => (
                        <option value={b.branchId}>{b.branchName}</option>
                      ))}
                  </select>
                  {errors.name === false ? (
                    <div className="validationerror">Please select branch </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    value={values.name}
                    name="name"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("name")}
                    placeholder="Please Enter Name"
                    maxLength={45}
                  />
                  {errors.name === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="phoneNumber" className="form-label">
                    Mobile(UserName)
                  </label>
                  <input
                    type="text"
                    value={values.phoneNumber}
                    name="phoneNumber"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("phoneNumber")}
                    placeholder="Please Enter Phone"
                    maxLength={15}
                  />
                  {errors.phoneNumber === false ? (
                    <div className="validationerror">Please enter phone </div>
                  ) : (
                    ""
                  )}
                </div>
                {values.userId === "00000000-0000-0000-0000-000000000000" ? (
                  <div className="col-lg-4 mb-3">
                    <label htmlFor="name" className="form-label">
                      Password
                    </label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        maxLength={45}
                        value={values.password}
                        name="password"
                        onChange={handleInputChange}
                        className={"form-control" + applyErrorClass("password")}
                        placeholder="Please Enter Password"
                      />
                      <span
                        className="position-absolute"
                        style={{
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? (
                          <i className="ri-eye-line"></i>
                        ) : (
                          <i className="ri-eye-off-line"></i>
                        )}
                      </span>
                    </div>
                    {errors.password === false ? (
                      <div className="validationerror">
                        Please enter password{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className="col-lg-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    value={values.email}
                    name="email"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("email")}
                    placeholder="Please Enter Email"
                    maxLength={45}
                  />
                  {errors.email === false ? (
                    <div className="validationerror">Please enter email </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.userId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        {/* Change Password Modal */}
        <Modal show={changeShow} onHide={handleChangeClose}>
          <Modal.Header>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleChangePassword} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Password
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      maxLength={45}
                      value={values.password}
                      name="password"
                      onChange={handleInputChange}
                      className={"form-control" + applyErrorClass("password")}
                      placeholder="Please Enter Password"
                    />
                    <span
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <i className="ri-eye-line"></i>
                      ) : (
                        <i className="ri-eye-off-line"></i>
                      )}
                    </span>
                  </div>
                  {errors.password === false ? (
                    <div className="validationerror">
                      Please enter password{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        Change Password
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        {/* Status Change Modal - Simplified */}
        <Modal show={showStatusModal} onHide={handleCloseStatusModal} centered>
          <Modal.Body className="text-center p-5">
            <div className="mb-4">
              <h4>
                {itemToChangeStatus?.isActive ? "Inactive User" : "Active User"}
              </h4>
              <p className="text-muted mt-2">
                Are you sure you want to{" "}
                {itemToChangeStatus?.isActive ? "inactive" : "active"} user{" "}
                <strong>{itemToChangeStatus?.name}</strong>?
              </p>
            </div>
            <div className="d-flex justify-content-center gap-3">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleCloseStatusModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${
                  itemToChangeStatus?.isActive ? "btn-primary" : "btn-success"
                }`}
                onClick={handleStatusChange}
              >
                {itemToChangeStatus?.isActive ? "Inactive" : "Active"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>

      <style>{`
                .badge.bg-success {
                    background: linear-gradient(45deg, #198754, #2ea65c);
                }
                .badge.bg-danger {
                    background: linear-gradient(45deg, #dc3545, #e63749);
                }
                .badge {
                    padding: 0.5em 0.8em;
                    border-radius: 20px;
                    font-weight: 500;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
                }
            `}</style>
    </div>
  );
};

export default Users;
